import { PremiumCurrencyFormatter } from '@wix/premium-react-text';
import * as React from 'react';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
import s from '../Cycles/Cycles.scss';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Country } from 'enums';
import { withInjectedRootStore, RootStore } from 'providers';
import { CycleDetails } from 'types';

interface SaleBadgeProps {
  cycle: CycleDetails;
  rootStore: RootStore;
  isCycleSelected: boolean;
}

const SaleBadgeComp: React.FC<SaleBadgeProps> = ({
  cycle,
  rootStore,
  isCycleSelected,
}) => {
  const {
    fullTermActualPrice,
    fullTermDisplayPrice,
    firstPeriodPrice,
    cycleId,
  } = cycle;
  const { country } = rootStore.appStore.appContext;
  const { theme } = usePageModeContext();
  const isBrazil = country === Country.BR;

  const stateClasses = isCycleSelected
    ? !isBrazil
      ? 'bg-colors white-colors bg-colors-after border-color border-color-after'
      : 'bg-colors white-colors bg-colors-after'
    : 'default-colors';

  const borderStyles = !isBrazil
    ? [s.subscriptionPageSaleOptimisations8651]
    : ['border-color', 'border-color-after'];

  const badgeClassNames = [s.saleBadge, stateClasses, ...borderStyles];

  return (
    <div
      data-hook={`sale-badge-${cycleId}`}
      className={classNames(badgeClassNames, theme, {
        [s.brazilBadge]: isBrazil,
      })}
    >
      <span className={classNames(s.saleBadgeContent, s.fontUpgrade, theme)}>
        <PremiumCurrencyFormatter
          currencySettingsOverride={{ fractionSize: 0 }}
          render={(formatCurrency) => (
            <Trans
              i18nKey='cycle_entry.cycle_discount'
              values={{
                discount: formatCurrency(
                  fullTermDisplayPrice -
                    (firstPeriodPrice || fullTermActualPrice),
                ),
              }}
            >
              Part 1<span className={s.salePriceText}>Part 2</span>
            </Trans>
          )}
        />
      </span>
    </div>
  );
};

export const SaleBadge = withInjectedRootStore(SaleBadgeComp);
